import { X } from 'lucide-react'
import {
  ModalCloseButton,
  StyledDropdownModal,
  StyledDropdownModalContent,
} from './styles'

interface Props {
  children: React.ReactNode
  close: () => void
  isOpen: boolean
}

export const ModalWrapper = ({ children, isOpen, close }: Props) => {
  if (!isOpen) return null

  return (
    <StyledDropdownModal isOpen={isOpen}>
      <ModalCloseButton onClick={close}>
        <X size={18} />
      </ModalCloseButton>
      <StyledDropdownModalContent>{children}</StyledDropdownModalContent>
    </StyledDropdownModal>
  )
}
